import React from 'react';
import { SaveManager, type SaveSlot } from '../utils/SaveManager';

interface SaveLoadMenuProps {
  saveSlots: (SaveSlot | null)[];
  isSaving: boolean;
  onSave: (slotId: number) => void;
  onLoad: (slotId: number) => void;
  onDelete: (slotId: number) => void;
  onClose: () => void;
}

export const SaveLoadMenu: React.FC<SaveLoadMenuProps> = ({
  saveSlots,
  isSaving,
  onSave,
  onLoad,
  onDelete,
  onClose
}) => {
  return (
    <div className="save-load-overlay" onClick={onClose}>
      <div className="save-load-menu" onClick={(e) => e.stopPropagation()}>
        <h2 className="save-load-title">
          {isSaving ? 'Save Game' : 'Load Game'}
        </h2>

        <div className="save-slots">
          {saveSlots.map((slot, index) => {
            const slotId = index + 1;
            const hasSave = slot !== null;

            return (
              <div key={slotId} className={`save-slot ${hasSave ? 'has-save' : 'empty'}`}>
                <div className="slot-number">Slot {slotId}</div>

                {hasSave ? (
                  <div className="slot-content">
                    <div className="slot-info">
                      <div className="slot-player">{slot.playerName}</div>
                      <div className="slot-world">{slot.worldName}</div>
                      <div className="slot-meta">
                        <span>Turn {slot.turnCount}</span>
                        <span>{SaveManager.formatDate(slot.timestamp)}</span>
                      </div>
                    </div>
                    <div className="slot-actions">
                      {isSaving ? (
                        <button
                          className="btn-save"
                          onClick={() => onSave(slotId)}
                        >
                          Overwrite
                        </button>
                      ) : (
                        <button
                          className="btn-load"
                          onClick={() => onLoad(slotId)}
                        >
                          Load
                        </button>
                      )}
                      <button
                        className="btn-delete"
                        onClick={() => onDelete(slotId)}
                      >
                        Delete
                      </button>
                    </div>
                  </div>
                ) : (
                  <div className="slot-empty-content">
                    <div className="empty-text">Empty Slot</div>
                    {isSaving && (
                      <button
                        className="btn-save"
                        onClick={() => onSave(slotId)}
                      >
                        Save Here
                      </button>
                    )}
                  </div>
                )}
              </div>
            );
          })}
        </div>

        <button className="btn-close" onClick={onClose}>
          Close
        </button>
      </div>
    </div>
  );
};

interface SettingsMenuProps {
  soundEnabled: boolean;
  musicEnabled: boolean;
  onToggleSound: () => void;
  onToggleMusic: () => void;
}

export const SettingsMenu: React.FC<SettingsMenuProps> = ({
  soundEnabled,
  musicEnabled,
  onToggleSound,
  onToggleMusic
}) => {
  return (
    <div className="settings-panel">
      <div className="setting-item">
        <button
          className={`setting-btn ${soundEnabled ? 'active' : ''}`}
          onClick={onToggleSound}
          title={soundEnabled ? 'Sound: ON' : 'Sound: OFF'}
        >
          🔊
        </button>
      </div>
      <div className="setting-item">
        <button
          className={`setting-btn ${musicEnabled ? 'active' : ''}`}
          onClick={onToggleMusic}
          title={musicEnabled ? 'Music: ON' : 'Music: OFF'}
        >
          🎵
        </button>
      </div>
    </div>
  );
};
